import { memo } from "react";
import CountrySelector from "../../CountrySelector";
import type { CountryIso2Props } from "./types";
import useCountryIso2 from "./useCountryIso2";

const CountryIso2Adapter = (props: CountryIso2Props) => {
    const {
        value,
        // getOptionLabel, 
        handleChange,
    } = useCountryIso2(props);

    return (
        <CountrySelector
            size='small'
            {...props}
            OptionProps={{
                mode: 'iso2'
            }}
            value={value}
            onChange={handleChange}
        />
    );
};

export default memo(CountryIso2Adapter);
